module.exports = __webpack_public_path__ + "img/cit.5f893419.jpg";